module.exports = __webpack_public_path__ + "vue-app/img/curve-vert-big.6a1e1e22.svg";